// OFD API Utilities and Exception Handling

import { AxiosError } from 'axios';

export class OfdApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: unknown; };
  result: unknown;

  constructor(message: string, status: number, response: string, headers: { [key: string]: unknown; }, result: unknown) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isOfdApiException = true;

  static isOfdApiException(obj: unknown): obj is OfdApiException {
    return typeof obj === 'object' && obj !== null && (obj as { isOfdApiException?: boolean }).isOfdApiException === true;
  }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: unknown; }, result?: unknown): never {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new OfdApiException(message, status, response, headers, null);
}

export function isAxiosError(obj: unknown): obj is AxiosError {
  return typeof obj === 'object' && obj !== null && (obj as { isAxiosError?: boolean }).isAxiosError === true;
}
